import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth, dashboardPathFor } from "@/contexts/AuthContext";
import SolimoesLogo from "./SolimoesLogo";
import { LogIn, UserPlus } from "lucide-react";

export default function PublicHeader() {
  const { user } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="fixed top-0 inset-x-0 z-50 glass-header border-b border-slate-100/60" data-testid="public-header">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-3" data-testid="header-home-link">
          <SolimoesLogo className="h-12 w-auto" />
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-[15px] font-medium text-slate-700">
          <NavLink to="/" end className={({isActive}) => isActive ? "text-[#0E2A5C]" : "hover:text-[#2A8FE0] transition"} data-testid="nav-home">Início</NavLink>
          <NavLink to="/planos" className={({isActive}) => isActive ? "text-[#0E2A5C]" : "hover:text-[#2A8FE0] transition"} data-testid="nav-planos">Planos</NavLink>
          <NavLink to="/rede" className={({isActive}) => isActive ? "text-[#0E2A5C]" : "hover:text-[#2A8FE0] transition"} data-testid="nav-rede">Rede Credenciada</NavLink>
          <NavLink to="/sobre" className={({isActive}) => isActive ? "text-[#0E2A5C]" : "hover:text-[#2A8FE0] transition"} data-testid="nav-sobre">Sobre</NavLink>
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <button
              onClick={() => navigate(dashboardPathFor(user.role))}
              className="btn-primary text-sm"
              data-testid="header-go-dashboard"
            >
              Meu Painel
            </button>
          ) : (
            <>
              <Link to="/entrar" className="hidden sm:inline-flex items-center gap-2 px-5 py-2 rounded-full font-medium text-[#0E2A5C] hover:text-[#2A8FE0] transition" data-testid="header-login-link">
                <LogIn className="h-4 w-4" /> Entrar
              </Link>
              <Link to="/cadastro" className="btn-primary text-sm" data-testid="header-register-link">
                <UserPlus className="h-4 w-4" /> Solicitar Cartão
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
